import React from "react";
import { NextPage } from "next";

import { DataProcessingBussinessRoute as DataProcessingBussiness } from "scenes/DataProcessing";

const Index: NextPage = () => <DataProcessingBussiness />;

export default Index;
